var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.93718 4.96871C9.93718 7.44957 7.18503 10.0333 6.26086 10.8312C6.17476 10.896 6.06996 10.931 5.96224 10.931C5.85452 10.931 5.74972 10.896 5.66363 10.8312C4.73945 10.0333 1.9873 7.44957 1.9873 4.96871C1.9873 3.91449 2.40609 2.90345 3.15154 2.15801C3.89698 1.41256 4.90802 0.993774 5.96224 0.993774C7.01646 0.993774 8.0275 1.41256 8.77295 2.15801C9.51839 2.90345 9.93718 3.91449 9.93718 4.96871Z",
    stroke: "#FDC700",
    strokeWidth: 0.993734,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96228 6.45935C6.78552 6.45935 7.45288 5.79199 7.45288 4.96875C7.45288 4.14551 6.78552 3.47815 5.96228 3.47815C5.13904 3.47815 4.47168 4.14551 4.47168 4.96875C4.47168 5.79199 5.13904 6.45935 5.96228 6.45935Z",
    stroke: "#FDC700",
    strokeWidth: 0.993734,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9248,
    height: 11.9248,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/location icon.69e440b3db65a161829fe6334ccc7196.svg";
export { ForwardRef as ReactComponent };